<div class="row">
  <div class="login-intro col-12 col-lg-7 order-2">
    <div class="login-copy">
      <div class="login-image">
        <adp-image imageKey="Signup_Create_Account_Main_Image"></adp-image>
      </div>
    </div>
  </div>
  <div class="login col-12 col-lg-5 order-1">
    <div class="login-form">
      <div id="sign-in-widget">
        <div class="header-text mb-4" role="heading" aria-level="1">{{heading}}</div>
        <p class="mb-4">
          <adp-label labelKey="Signup_Create_Account_NewEmail_Body_Text"></adp-label>
        </p>
      </div>
      <div class="email-flow">
        <form (ngSubmit)="recaptchaExecute(captchaRef)" [formGroup]="findContractForm">
          <div class="email-form">
            <adp-input pgh-autofocus class="w-100" formControlName="emailControl"
              [resourceData]="emailResourceData" [inputId]="'Signup_Create_Account_EmailAddress_Field'"
              (blur)="onBlurEmailField()"></adp-input>
            <mat-error *ngIf="validationError" class="email-error">{{validationError}}</mat-error>
            <div class="form-group mb-4" [ngClass]="{'mt-4': validationError}">
              <button mat-flat-button color="accent" type="submit"
                [tabindex]="(!emailControl.value || isEmailNotValid) ? '-1' : '0'">
                <adp-label labelKey="Signup_Create_Account_NewEmail_SubmitButton_Text"></adp-label>
              </button>
            </div>
          </div>
        </form>
        <hr style="margin: auto; width: 90%;">
        <div class="mt-4" style="text-align: center; display: block;">
          <adp-label labelKey="Signup_Create_Account_NewEmail_BackToLogin_Text"></adp-label>&nbsp;
          <a href="javascript:void(0)" (click)="goToLogin()" [gtmClick]="getViewLabel('Signup_Create_Account_Login_Text')">
            <adp-label labelKey="Signup_Create_Account_Login_Text"></adp-label>
          </a>
        </div>
      </div>
      <re-captcha class="d-inline-block" size="invisible" [siteKey]="reCaptchaInvisbleKey"
        (resolved)="$event && createAccount($event, captchaRef)" #captchaRef="reCaptcha">
      </re-captcha>
    </div>
  </div>
</div>
